import { get, values } from "lodash-es";

export const getError = (error: any) => {
	const arrayOfErrors: string[][] = values(
		get(error, "response.data.errors", null),
	);
	let allErrors: string = "";

	if (arrayOfErrors.length) {
		allErrors = concatErrorMessagges(arrayOfErrors, allErrors);
	}

	return get(
		error,
		"response.data.message",
		get(
			error,
			"response.data.result",
			get(
				error,
				"response.data.detail",
				get(error, "response.data.title", error.toString()) + " " + allErrors,
			),
		),
	);
};

const concatErrorMessagges = (arrayOfErrors: string[][], string: string) => {
	arrayOfErrors.forEach((element: string[], index: number): void => {
		if (index !== 0) {
			string += ". ";
		}
		string += element.join("");
	});

	return string;
};
